"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SmProgressBar = void 0;
/* eslint-disable jsx-a11y/control-has-associated-label */
const react_1 = __importStar(require("react"));
exports.SmProgressBar = (0, react_1.forwardRef)((_a, ref) => {
    var { value, steps } = _a, props = __rest(_a, ["value", "steps"]);
    const percentage = (0, react_1.useMemo)(() => {
        if (value === 100) {
            return 100;
        }
        const quadrant = Math.floor(100 / steps); // (100 / 6 = 16,666666667)
        const greatestQuadrant = quadrant * steps; // (16 * 6 = 96 )
        return value >= greatestQuadrant // (97 >= 96)
            ? quadrant * (Math.floor(value / quadrant) - 1) // (97 / 16 = 6) ( 6 -1 = 5) ( 16 * 5 = 80)
            : quadrant * Math.floor(value / quadrant);
    }, [value]);
    return (react_1.default.createElement("div", { className: "c-progress" },
        react_1.default.createElement("div", Object.assign({}, props, { ref: ref, className: "c-progress__counter", role: "progressbar", "aria-valuenow": value, "aria-valuemin": 0, "aria-valuemax": 100, style: { width: `${percentage}%` } }))));
});
//# sourceMappingURL=index.js.map